module.exports = __webpack_public_path__ + "img/logo.d8d88021.svg";